import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import Typography from "@mui/material/Typography";

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import ButtonBase from '@mui/material/ButtonBase';
import IconButton from '@mui/material/IconButton';


import * as Bs4Utils from '../../Bs4Components/Bs4Utils'
import { ViewBs4EventDay } from './Bs4ReportCalendarViewBs4Event';
import { getBoxSx, getBoxStyle } from '../../Bs4Theme/Bs4UxTemplates';
import { SmallScreenContext, useStateUxTemplate } from '../../Bs4Theme/Bs4UxTemplates';

import { useDroppable } from '@dnd-kit/core';

import {  
  subMilliseconds,
  startOfDay, endOfDay,
  startOfWeek, endOfWeek,  
  compareAsc,
  eachHourOfInterval, eachDayOfInterval, eachMonthOfInterval,
  format,
  differenceInMilliseconds,
  roundToNearestMinutes,
  addMilliseconds, addMinutes,
  max, min,
  differenceInMinutes, differenceInHours, differenceInDays, differenceInCalendarDays,
  addHours, 
  getWeek, getYear,
} from 'date-fns';

import {   
  // TYPE_NAVIGATION,
  // TYPE_CALENDAR,
  // TYPE_AGENDE,
  // TYPE_SCHEDULER,
  // TYPE_MODIFIER,

  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,

  // VIEW_TYPE_MODIFIER_LAYER0,
  // VIEW_TYPE_MODIFIER_LAYER1,
  // VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH,

  // footerButtons,
  // isSelected,
  borderColor,
  borderWidth,
} from './Bs4ReportCalendarConst';

import Bs4ReportCalendarView from './Bs4ReportCalendarView'
import { ViewPeriodBackground, ViewPeriodForeground } from './Bs4ReportCalendarViewPeriod'
import { time } from 'echarts';

const DROPPABLE = 'droppable';

const HeaderButton = styled(ButtonBase)(({ theme }) => ({ 
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: '#00000007'
  },
}));

export default class Bs4ReportCalendarViewDays extends Bs4ReportCalendarView {

  scrollMargin = 5;

  borderStart = {
    borderLeft: `solid ${borderColor}`, 
    borderTop: `solid ${borderColor}`,     
    borderWidth: borderWidth,
  }

  borderLeft = {
    borderLeft: `solid ${borderColor}`, 
    borderWidth: borderWidth,
  }

  borderEnd = {
    borderRight: `solid ${borderColor}`, 
    borderBottom: `solid ${borderColor}`,
    borderWidth: borderWidth,
  }

  borderRight = {
    borderRight: `solid ${borderColor}`,   
    borderWidth: borderWidth,
  }

  borderBottom = {
    borderBottom: `solid ${borderColor}`,
    borderWidth: borderWidth,
  }

  y_d = 'y-D';
  
  ViewPeriodName = (props) => {
    const report = this;

    const View = React.useMemo(() => {
      const monthArray = eachMonthOfInterval({start:props.startPeriod, end: props.endPeriod});
      if (monthArray.length === 2) {
        if (getYear(monthArray[0]) === getYear(monthArray[1])) {
          return (
            <Stack direction="row" spacing={0.5} sx={{justifyContent: "center", alignItems: "baseline", ...props.sx}}>
              <Typography>{format(monthArray[0], 'LLL')}</Typography>
              <Typography>{'-'}</Typography>
              <Typography>{format(monthArray[1], 'LLL yyyy')}</Typography>
              <Typography variant='caption' sx={{opacity: 0.6}}>&nbsp;{'t.'+getWeek(props.startPeriod)}</Typography>
            </Stack>
          )
        } else {
          return (
            <Stack direction="row" spacing={0.5} sx={{justifyContent: "center", alignItems: "baseline", ...props.sx}}>
              <Typography>{format(monthArray[0], 'LLL yyyy')}</Typography>
              <Typography>{'-'}</Typography>
              <Typography>{format(monthArray[1], 'LLL yyyy')}</Typography>
              <Typography variant='caption' sx={{opacity: 0.6}}>&nbsp;{'t.'+getWeek(props.startPeriod)}</Typography>
            </Stack>
          )
        }
      }

      return (
        <Stack direction="row" spacing={0.5} sx={{justifyContent: "center", alignItems: "baseline", ...props.sx}}>
          <Typography>{format(props.startPeriod, 'LLL yyyy')}</Typography>              
          <Typography variant='caption' sx={{opacity: 0.6}}>&nbsp;{'t.'+getWeek(props.startPeriod)}</Typography>
        </Stack>  
      )
    }, [props.startPeriod, props.endPeriod])
  
    return View
  }

  ViewDayName = (props) => {
    const report = this;
    const theme = useTheme();

    const handleNavigateTo = () => {    
      if (props.bs4Calendar.viewType === VIEW_TYPE_DAY) return;
      props.onChangeView(props.date, VIEW_TYPE_DAY);
    }
    
    const square = 40;
  
    return (
      <Box 
        flex={1} 
        display='flex'
        flexDirection='column'
        justifyContent='center' 
        alignItems='center'
        paddingBottom={1}
      >        
        {/* <Typography variant='body2' sx={{userSelect: 'none', fontSize: '12px'}}>{format(props.date, 'iii')}</Typography> */}
        <HeaderButton
          onClick={handleNavigateTo}
          disabled={Boolean(props.bs4Calendar.viewType === VIEW_TYPE_DAY)}
          size='small'
        >       
          {props.bs4Calendar.viewType === VIEW_TYPE_DAY ?
            <Stack 
              direction="row" 
              sx={{
                justifyContent: "center", 
                //alignItems: "center",
                alignItems: "baseline",
              }}
            >
              <Typography>&nbsp;{format(props.date, 'EEEE, dd LLLL yyyy')}</Typography>
              <Typography variant='caption' sx={{opacity: 0.6}}>&nbsp;{'t.'+getWeek(props.date)}</Typography>
            </Stack>
          :
            <Typography>&nbsp;{format(props.date, 'iii dd')}</Typography>
          }                    
        </HeaderButton>       
      </Box> 
    )
  }

  ViewDay = (props) => {
    const report = this;

    const minWidth = 25;
    const minHeight = 25;

    const handleNavigateTo = () => {    
      props.onChangeView(props.date, VIEW_TYPE_DAY);
    }

    return (
      <Box 
        flex={1} display='flex' 
        flexDirection='column' 
        sx={{...report.borderEnd}}
      >
        <Box display='flex' flexDirection='row' justifyContent='flex-end' alignItems='center'>
          <IconButton
            onClick={handleNavigateTo}
            size='small'
            sx={{            
              width: minWidth,
              height: minHeight,            
            }}
          >
            <Typography variant='subtitle2'>{format(props.date, 'd')}</Typography>
          </IconButton>          
        </Box>
        <Box
          id='Box_Bs4ReportCalendarMonth_ViewDay_content'
          flex={1}
        >
        </Box>
      </Box>
    )
  }

  getSortedBs4Events = (day) => {
    if (!day) return [];
    const viewArray = day.bs4EventArray.reduce((array, bs4Event) => {
      const bs4EventStart = max([day.startVisibleDay, bs4Event.start]);
      const bs4EventEnd = min([day.endVisibleDay, bs4Event.end]);
      array.push({
        bs4Event: bs4Event,
        start: bs4EventStart,
        end: bs4EventEnd,        
      });
      return array;
    }, []);
        
    const viewSorted = viewArray.sort((a, b) => {
      let comparison = (b.end.getTime() - b.start.getTime()) - (a.end.getTime() - a.start.getTime());
      if (comparison === 0) comparison = a.start.getTime() - b.start.getTime();
      if (comparison === 0) comparison = b.end.getTime() - a.end.getTime();
      return comparison;
    });    

    const lineArray = [];
    for (let el of viewSorted) {
      let pushed = false;
      for (let i = 0; i < lineArray.length; i++) {
        const line = lineArray[i];
        let foul = false;
        for (let elp of line) {
          if (!(el.end < elp.start.getTime() || el.start.getTime() > elp.end.getTime())) {
            foul = true;
            break;
          };
        }

        if (!foul) {
          line.push(el);
          pushed = true;
          break;
        }
      }

      if (!pushed) {
        el.line = lineArray.length;        
        lineArray.push([el]);
      }
    }
    
    return lineArray;
  }

  handleTouchStartTimeout = null;

  ViewDayHours = React.memo(props => {
    const report = this;    

    const lineArray = React.useMemo(() => {
      return this.getSortedBs4Events(props.day);
    }, [props.day.bs4EventArray]);

    const activeLineArray = React.useMemo(() => {
      const lineArray = this.getSortedBs4Events(props.activeDay);
      if (lineArray.length > 1) {
        //console.log('...???...', lineArray, props.activeDay)
      }
      return lineArray
    }, [props.activeDay?.bs4EventArray]);

    const setBs4ActiveMove = React.useCallback((active, over, propsEnd) => {      
      const el = active.props.el;
      if (!el.bs4Event.chtime) return;
      
      if (!over) {
        if (propsEnd) {
          if (el.bs4Event.move.cursor) {
            propsEnd.bs4EventResize(el.bs4Event);
          } else {
            propsEnd.bs4EventDrop(el.bs4Event);
          }
        }        
        return;
      }

      const rect = over.rect;
      const pointerCoordinates = over.data.current.droppableRef.pointerCoordinates;      
      // const moveDate = addMilliseconds(props.day.start, differenceInMilliseconds(props.day.end, props.day.start) / rect.height * (pointerCoordinates.y - rect.top));
      const moveDate = addMilliseconds(props.day.startVisibleDay, differenceInMilliseconds(props.day.endVisibleDay, props.day.startVisibleDay) / rect.height * (pointerCoordinates.y - rect.top));
      
      if (el.bs4Event.move.cursor) {
        if (el.bs4Event.move.cursor === 'n' || el.bs4Event.move.cursor === 'w') {
          const start = props.bs4Calendar.roundTo(moveDate);
          if (compareAsc(start, el.bs4Event.end) > 0) return;
          if (compareAsc(start, el.bs4Event.start) === 0) return;
          el.bs4Event.start = start;
          el.bs4Event.duration = differenceInMilliseconds(el.bs4Event.end, el.bs4Event.start);
        } else if (el.bs4Event.move.cursor === 's' || el.bs4Event.move.cursor === 'e') {
          const end = props.bs4Calendar.roundTo(moveDate);
          if (compareAsc(el.bs4Event.start, end) > 0) return;
          if (compareAsc(end, el.bs4Event.end) === 0) return;
          el.bs4Event.end = end;
          el.bs4Event.duration = differenceInMilliseconds(el.bs4Event.end, el.bs4Event.start);
        }
      } else {
        const differenceInMillisecondsMove = differenceInMilliseconds(moveDate, el.bs4Event.move.moveDate);
        const start = props.bs4Calendar.roundTo(addMilliseconds(el.bs4Event.move.start, differenceInMillisecondsMove));
        if (compareAsc(start, el.bs4Event.start) === 0) return;
        el.bs4Event.start = start;
        el.bs4Event.end = addMilliseconds(el.bs4Event.start, el.bs4Event.duration);
      }
      if (navigator.vibrate) navigator.vibrate(1);
    }, [props.day.start, props.day.end, props.bs4Calendar?.roundTo]);
    
    const percentNow = React.useMemo(() => {
        const now = new Date();
        const startDayTime = props.day.startVisibleDay.getTime() || 1;
        const endDayTime = props.day.endVisibleDay.getTime() || 1;
        
        const nowTime = now.getTime();
      
        const percentNow = ((1.0 * (nowTime - startDayTime)) / (endDayTime - startDayTime)) * 100.0;
        if (percentNow < 1 || percentNow > 100) return null;
        return percentNow;
      }, [props.day])
    
    const [droppableRef, setDroppableRef] = React.useState({})

    const {isOver, active, setNodeRef, node} = useDroppable({
      id: DROPPABLE+'_'+VIEW_TYPE_DAY+'_'+Bs4Utils.toDate(props.day.start),
      data: {
        setBs4ActiveMove: setBs4ActiveMove,
        droppableRef: droppableRef,
      }
    });    
    
    return (
      <Box
        ref={setNodeRef}
        gridColumn={(props.indexColumn+1)+'/'+(props.indexColumn+2)}
        gridRow='r-start/r-end'
        position='relative'
        sx={{...report.borderRight, }}
      >        
        {percentNow ? 
          <Box 
            sx={{
              position: 'absolute',
              top: percentNow+'%',
              left: 0,
              right: 0,
              height: '0px',
              userSelect: 'none',        
              pointerEvents: 'none',
              borderTop: '3px dashed #ff000022',
              zIndex: 200,
            }}          
          >
          </Box> 
          : null
        }
        {lineArray.map((line, index) => {          
          return line.map(el => {
            if (el.bs4Event?.move?.active) return null;
            return (
              <ViewBs4EventDay
                key={el.bs4Event.key+el.start+el.end}
                day={props.day}
                el={el}
                line={index}
                maxLines={lineArray.length}
                bs4kartotekaid={props.bs4KartotekaId}
                onRowClick={props.onRowClick}
                onChangeView={props.onChangeView}
                bs4Calendar={props.bs4Calendar}
              />
            )
          })            
        })}

        {activeLineArray.map((line, index) => {          
          return line.map(el => {
            return (
              <ViewBs4EventDay
                key={el.bs4Event.key+el.start+el.end}
                day={props.day}
                el={el}
                line={index}
                maxLines={activeLineArray.length}
                bs4kartotekaid={props.bs4KartotekaId}
                onRowClick={props.onRowClick}
                onChangeView={props.onChangeView}
                bs4Calendar={props.bs4Calendar}
              />
            )
          })            
        })}
      </Box>
    )
  });


  setActiveNew = (pageX, pageY, dayArray, refBox, props) => {    
    const rect = refBox.current.getBoundingClientRect();
    if (!rect) return;

    const dayNumber = Math.floor(dayArray.length * (pageX - rect.left) / rect.width);
    const day = dayArray[dayNumber];
    if (!day) return;

    // const moveDate = addMilliseconds(props.day.start, differenceInMilliseconds(props.day.end, props.day.start) / rect.height * (pointerCoordinates.y - rect.top));
    // const moveDate = addMilliseconds(props.day.startVisibleDay, differenceInMilliseconds(props.day.endVisibleDay, props.day.startVisibleDay) / rect.height * (pointerCoordinates.y - rect.top));
    let start = addMilliseconds(day.startVisibleDay, differenceInMilliseconds(day.endVisibleDay, day.startVisibleDay) / rect?.height * (pageY - rect?.top));
    start = props.bs4Calendar.roundTo(start);      
    const end = addMinutes(start, props.bs4Calendar.nearestTo);
    const newBs4Event = {
      Name: 'New bs4Event',
      start, 
      end,
      duration: differenceInMilliseconds(end, start),
      chtime: true,
      new: true,
      move: {
        cursor: 's',
        active: true,
      },
    }          
    props.setActive({props: {el: {bs4Event: newBs4Event}}});
    if (navigator.vibrate) navigator.vibrate(30);  
  };

  moveActivwNew = (pageX, pageY, dayArray, refBox, props) => {    
    const rect = refBox.current.getBoundingClientRect();
    if (!rect) return;

    const dayNumber = Math.floor(dayArray.length * (pageX - rect.left) / rect.width);
    const day = dayArray[dayNumber];
    if (!day) return;
    
    let end = addMilliseconds(day.startVisibleDay, differenceInMilliseconds(day.endVisibleDay, day.startVisibleDay) / rect?.height * (pageY - rect?.top));
    end = props.bs4Calendar.roundTo(end);
    if (compareAsc(props.active.props.el.bs4Event.start, end) > 0) return;

    props.active.props.el.bs4Event.end = end;
    props.setActiveChangeTime(new Date());
    if (navigator.vibrate) navigator.vibrate(1);
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const refScroll = React.useRef(null);
    const refBox = React.useRef(null);
    const  [dayArray, bs4EventallDayArray] = React.useMemo(() => {
      const dayObject = {};
      const bs4EventallDayArray = [];
      props.bs4Calendar.getVisibleEvents().forEach((bs4Event, index) => {
        if (compareAsc(bs4Event.end, props.bs4Calendar.start) < 0) return;
        if (compareAsc(bs4Event.start, props.bs4Calendar.end) > 0) return;

        const start = max([bs4Event.start, props.bs4Calendar.start]);
        const end = min([bs4Event.end, props.bs4Calendar.end]);
        const difference = differenceInCalendarDays(end, start);
        
        if (difference === 0) {
          const startVisibleDay = props.bs4Calendar.getStartVisibleDay(start);
          const endVisibleDay = props.bs4Calendar.getEndVisibleDay(end);
          if (compareAsc(end, startVisibleDay) <= 0 || compareAsc(start, endVisibleDay) >= 0) {
            bs4EventallDayArray.push(bs4Event);
            return;
          }
        }

        if (difference === 1) {          
          const startVisibleDay = props.bs4Calendar.getStartVisibleDay(end);
          const endVisibleDay = props.bs4Calendar.getEndVisibleDay(start);
          if (compareAsc(start, endVisibleDay) >= 0 && compareAsc(end, startVisibleDay) <= 0) {
            bs4EventallDayArray.push(bs4Event);
            return;
          }
        }        

        if (bs4Event.AllDay === true) {
          bs4EventallDayArray.push(bs4Event);
          return;
        } 

        eachDayOfInterval({start: bs4Event.start, end: bs4Event.end}).forEach(date => {
          if (compareAsc(bs4Event.end, startOfDay(date)) < 0) return;
          if (compareAsc(bs4Event.start, endOfDay(date)) > 0) return;
          const key = format(date, this.y_d, {useAdditionalDayOfYearTokens: true});
          let bs4EventArray = dayObject[key];
          if (!bs4EventArray) {
            bs4EventArray = [];
            dayObject[key] = bs4EventArray;
          }
          bs4EventArray.push(bs4Event);
        })        
      });

      const dayArray = eachDayOfInterval({start: props.bs4Calendar.start, end: props.bs4Calendar.end}).map(dayDate => {
        return {
          start: startOfDay(dayDate),
          end: endOfDay(dayDate),
          startVisibleDay: props.bs4Calendar.getStartVisibleDay(dayDate),
          endVisibleDay: props.bs4Calendar.getEndVisibleDay(dayDate),
          bs4EventArray: dayObject[format(dayDate, this.y_d, {useAdditionalDayOfYearTokens: true})] || [],
        }
      })
      
      return [dayArray, bs4EventallDayArray];
    }, [props.bs4Calendar.start, props.bs4Calendar.hoursMinMax, props.bs4Calendar.end, props.calendarChangeTime])

    const activeDayArray = React.useMemo(() => {
      const dayObject = {};
      const bs4Event = props.active?.props?.el?.bs4Event;

      if (!bs4Event) return null;
      if (compareAsc(bs4Event.end, props.bs4Calendar.start) < 0) return null;
      if (compareAsc(bs4Event.start, props.bs4Calendar.end) > 0) return  null;
      if (bs4Event.AllDay === true) return null;
        
      try {
        eachDayOfInterval({start: bs4Event.start, end: bs4Event.end}).forEach(date => {
          if (compareAsc(bs4Event.end, startOfDay(date)) < 0) return;
          if (compareAsc(bs4Event.start, endOfDay(date)) > 0) return;
          const key = format(date, this.y_d, {useAdditionalDayOfYearTokens: true});
          let bs4EventArray = dayObject[key];
          if (!bs4EventArray) {
            bs4EventArray = [];
            dayObject[key] = bs4EventArray;
          }
          bs4EventArray.push(bs4Event);
        })
      } catch(error) {
        console.log(error)
        console.log('...eachDayOfInterval...', Bs4Utils.toDateTime(bs4Event.start),  Bs4Utils.toDateTime(bs4Event.end), bs4Event, props)
      }

      const dayArray = eachDayOfInterval({start: props.bs4Calendar.start, end: props.bs4Calendar.end}).map(dayDate => {
        return {
          start: startOfDay(dayDate),
          end: endOfDay(dayDate),
          startVisibleDay: props.bs4Calendar.getStartVisibleDay(dayDate),
          endVisibleDay: props.bs4Calendar.getEndVisibleDay(dayDate),
          bs4EventArray: dayObject[format(dayDate, this.y_d, {useAdditionalDayOfYearTokens: true})] || [],
        }
      })
      
      return dayArray;
    }, [props.bs4Calendar.start, props.bs4Calendar.end, props.active, props.activeChangeTime])

    const hours = React.useMemo(() => {
      const start0 = startOfDay(props.bs4Calendar.date);
      const end0 = endOfDay(props.bs4Calendar.date);
      const start = props.bs4Calendar.getStartVisibleDay(props.bs4Calendar.date);
      const end = props.bs4Calendar.getEndVisibleDay(props.bs4Calendar.date);      
      // console.log('...???...', Bs4Utils.toDateTimeSSS(start), Bs4Utils.toDateTimeSSS(end), props.bs4Calendar.hoursMinSec, props.bs4Calendar.hoursMaxSec);
      const hours = eachHourOfInterval({start: start, end: end}).map(date => {
        return date;
      });
      return hours;
    }, [props.bs4Calendar.date, props.bs4Calendar.hoursMinMax])
  
    const [overflow, setOverflow] = React.useState(true);

    const countH = 24;
    const heightH = 50;

    const scrollBy = (pageX, pageY) => {
      if (!props.active?.props?.el.bs4Event?.new) return;

      const rect = refScroll.current.getBoundingClientRect();

      if (!rect) return;
      
      const threshold = 50;
      const top = pageY - rect.top;
      const bottom = rect.bottom - pageY;
      if (top < threshold) {
        // refScroll.current.scrollBy(0, -(threshold - top / 2))      
        refScroll.current.scrollBy({
          top: -(threshold - top / 2),
          left: 0,
          behavior: "smooth",
        });
      }

      if (bottom < threshold) {
        // refScroll.current.scrollBy(0, threshold - bottom / 2)      
        refScroll.current.scrollBy({
          top: threshold - bottom / 2,
          left: 0,
          behavior: "smooth",
        });
      }
    }

    const handlePointerDown = React.useCallback((event) => {   
      if (event.pointerType === 'touch') return;
      if (!props.bs4Calendar?.allowaddevent) return;
      this.setActiveNew(event.pageX, event.pageY, dayArray, refBox, props);
    }, [props.bs4Calendar.allowaddevent, dayArray, refBox, props]);

    const handlePointerMove = React.useCallback((event) => {
      if (event.pointerType === 'touch') return;
      if (!props.active?.props?.el?.bs4Event?.new) return;
      this.moveActivwNew(event.pageX, event.pageY, dayArray, refBox, props);
      scrollBy(event.pageX, event.pageY);
    }, [props.active?.props?.el?.bs4Event?.new, dayArray, refBox, props, scrollBy]);

    const handlePointerUp = React.useCallback((event) => {
      if (event.pointerType === 'touch') return;      
      if (!props.active?.props?.el?.bs4Event?.new) return;
      props.bs4EventAdd(props.active?.props?.el?.bs4Event);
      props.setActive(null);
    }, [props.active?.props?.el?.bs4Event?.new, props.bs4EventAdd, props.setActive]);

    const handleTouchStart = React.useCallback((event) => {
      clearTimeout(this.handleTouchStartTimeout);
      if (!props.bs4Calendar?.allowaddevent) return;
      this.handleTouchStartTimeout = setTimeout(() => {
        const touch = event.touches[0];
        this.setActiveNew(touch.pageX, touch.pageY, dayArray, refBox, props);
        setOverflow(false);
      }, 500);      
    }, [props.bs4Calendar.allowaddevent, props.active, dayArray, refBox, props, setOverflow]);

    const handleTouchMove = React.useCallback((event) => {
      clearTimeout(this.handleTouchStartTimeout);
      if (!props.active?.props?.el?.bs4Event?.new) return;
      const touch = event.touches[0];
      this.moveActivwNew(touch.pageX, touch.pageY, dayArray, refBox, props);      
      scrollBy(touch.pageX, touch.pageY);
    }, [props.active?.props?.el?.bs4Event?.new, dayArray, refBox, props, scrollBy]);
    
    const handleTouchEnd  = React.useCallback((event) => {
      clearTimeout(this.handleTouchStartTimeout);
      setOverflow(true);
      if (!props.active?.props?.el?.bs4Event?.new) return;
      props.bs4EventAdd(props.active?.props?.el?.bs4Event);
      props.setActive(null);
    }, [props.active?.props?.el?.bs4Event?.new, props.bs4EventAdd, props.setActive, setOverflow]);

    const handleKeyDown  = React.useCallback((event) => {
      clearTimeout(this.handleTouchStartTimeout);
      if (event.code !== 'Escape') return;
      if (!props.active?.props?.el?.bs4Event?.new) return;      
      props.setActive(null);
    }, [props.active?.props?.el?.bs4Event?.new, props.setActive]);

    React.useEffect(() => {            
      window.addEventListener('pointermove', handlePointerMove);
      window.addEventListener('pointerup', handlePointerUp);

      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);

      window.addEventListener('keydown', handleKeyDown);

      return () => {
        window.removeEventListener('pointermove', handlePointerMove);
        window.removeEventListener('pointerup', handlePointerUp);

        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);

        window.removeEventListener('keydown', handleKeyDown);
      }
    }, [handlePointerMove, handlePointerUp, handleTouchMove, handleTouchEnd]);

    React.useEffect(() => {      
      if (props.setScrollTarget) props.setScrollTarget(refScroll.current, 'grid');
    }, [refScroll.current]);

    return (
      <Box 
        id='Box_Bs4ReportCalendarDays'
        height='100%'
        display='grid'
        gridTemplateColumns={`[cl-start] 60px [cl-start-days] repeat(${dayArray.length}, 1fr) [cl-end-days] auto [cl-end]`}
        gridTemplateRows={'auto auto auto 1fr'}        
        overflow='hidden'
        //height={'100%'}
      >
        <Box
          gridColumn='cl-start / cl-end'
          gridRow='1/3'
          display='grid'
          gridTemplateColumns='subgrid'
          gridTemplateRows='auto'
          // sx={{...report.borderBottom}}
        >
          {/* <Box          
            gridColumn='cl-start / cl-start-days'
            gridRow='1/3'
            sx={{...report.borderRight}}
          />*/}
          {props.bs4Calendar.viewType !== VIEW_TYPE_DAY ? 
            <report.ViewPeriodName 
              startPeriod={props.bs4Calendar.start} 
              endPeriod={props.bs4Calendar.end} 
              sx={{gridColumn: 'cl-start-days / cl-end-days', gridRow: '1/2',}}
            /> : null}
          <Box          
            gridColumn='cl-start-days / cl-end-days'
            gridRow='2/3'
            display='grid'
            gridTemplateColumns='subgrid'
            gridTemplateRows='subgrid'
          >
            {dayArray.map((day, indexColumn) => {
              return (                
                <Box
                  key={day.start}
                  gridColumn={(indexColumn+1)+'/'+(indexColumn+2)}
                  gridRow='1/2'         
                >
                  <report.ViewDayName 
                    date={day.start} bs4Calendar={props.bs4Calendar} onChangeView={props.onChangeView} />
                </Box>
              )
            })}
          </Box>  
        </Box>
        <Box
          gridColumn='cl-start / cl-end'
          gridRow='3/4'
          display='grid'
          gridTemplateColumns='subgrid'
          gridTemplateRows='auto'                    
          sx={{
            ...report.borderBottom,
          }}
        >
          <Box          
            gridColumn='cl-start / cl-start-days'
            gridRow='1/2'
            sx={{...report.borderRight}}            
          />
          <ViewPeriodBackground
            sx={{gridColumn: 'cl-start-days / cl-end-days', gridRow: '1/2'}}
            startPeriod={props.bs4Calendar.start} 
            endPeriod={props.bs4Calendar.end}
            bs4EventArray={bs4EventallDayArray}
            bs4kartotekaid={props.bs4KartotekaId}
            onRowClick={props.onRowClick}
            onChangeView={props.onChangeView}
            bs4Calendar={props.bs4Calendar}
          />
          <Box          
            gridColumn='cl-start-days / cl-end-days'
            gridRow='1/2'
            display='grid'
            position='relative'
            gridTemplateColumns='subgrid'
            gridTemplateRows='subgrid'
          >
            {dayArray.map((day, indexColumn) => {
              return (    
                <Box
                  key={day.start}
                  gridColumn={(indexColumn+1)+'/'+(indexColumn+2)}
                  gridRow='1/2'         
                  sx={{...report.borderRight}}
                />                  
              )
            })}
          </Box>            
          <ViewPeriodForeground
            sx={{gridColumn: 'cl-start-days / cl-end-days', gridRow: '1/2'}}
            startPeriod={props.bs4Calendar.start} 
            endPeriod={props.bs4Calendar.end} 
            bs4EventArray={bs4EventallDayArray}
            maxLine={5}
            bs4kartotekaid={props.bs4KartotekaId} 
            onRowClick={props.onRowClick}
            onChangeView={props.onChangeView}
            active={props.active?.props?.el?.bs4Event?.AllDay ? props.active : null}
            setActive={props.setActive}
            activeChangeTime={props.activeChangeTime}
            bs4EventAdd={props.bs4EventAdd}
            bs4Calendar={props.bs4Calendar}
          />
        </Box>
        <Box  
          ref={refScroll}
          gridColumn='cl-start / cl-end'
          gridRow='4/5'          
          overflow={overflow ? 'auto' : 'hidden'}          
          display='grid'
          gridTemplateColumns='subgrid'
          gridTemplateRows={`[r-start] repeat(${hours.length}, 1fr) [r-end]`}      
          sx={{
            overflowX: 'hidden',
          }}              
        >
          <Box
            position='relative'
            gridColumn='cl-start / cl-end'
            gridRow='r-start/r-end'          
            overflow='hidden'
            display='grid'
            gridTemplateColumns='subgrid'
            gridTemplateRows='subgrid'
          >
            {hours.map((date, index) => {
              return (
                <Box
                  key={date}   
                  gridColumn='cl-start / cl-end'
                  gridRow={(index+1)+'/'+(index+2)}
                  minHeight={heightH}
                  display='grid' 
                  gridTemplateColumns='subgrid'
                  gridTemplateRows='auto'
                >
                  <Box
                    gridColumn='cl-start / cl-start-days'
                    gridRow='1/2'
                    display='flex' 
                    justifyContent='flex-end'                   
                    alignItems='flex-start'
                    sx={{...report.borderRight}}
                  >
                    <Typography variant='body2' sx={{userSelect: 'none', fontSize: '12px', paddingRight: 1, marginTop: '-8px'}}>{format(date, 'HH:mm')}</Typography>
                    <Box height='100%' width={8} sx={{...report.borderBottom}}></Box>
                  </Box>
                  <Box
                    gridColumn='cl-start-days / cl-end-days'
                    gridRow='1/2'
                    sx={{...report.borderBottom}}
                  />                    
                </Box>
              )
            })}     
            <Box
              ref={refBox}              
              gridColumn='cl-start-days / cl-end-days'
              gridRow='r-start/r-end'
              display='grid'
              gridTemplateColumns='subgrid'
              gridTemplateRows='subgrid'   
              
              onPointerDown={handlePointerDown}
              onTouchStart={handleTouchStart}
            >
              {dayArray.map((day, index) => {
                return (
                  <report.ViewDayHours 
                    key={day.start} 
                    indexColumn={index} 
                    day={day}
                    activeDay={activeDayArray ? activeDayArray[index] : null}
                    bs4kartotekaid={props.bs4KartotekaId} 
                    onRowClick={props.onRowClick}
                    onChangeView={props.onChangeView}
                    active={props.active}
                    setActive={props.setActive}
                    bs4EventAdd={props.bs4EventAdd}
                    bs4Calendar={props.bs4Calendar}
                  />                
                )
              })}
            </Box>              
          </Box>    
        </Box>                   
      </Box>
    );
  });
}